// extracted by mini-css-extract-plugin
module.exports = {"grouper":"_2z-IHAturS8urVOopnEsEr"};